import { render, staticRenderFns } from "./ModalOverlay.vue?vue&type=template&id=6d8bc50d&scoped=true&"
import script from "./ModalOverlay.vue?vue&type=script&lang=js&"
export * from "./ModalOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ModalOverlay.vue?vue&type=style&index=0&id=6d8bc50d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8bc50d",
  null
  
)

export default component.exports